import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    visibility: false,
    id: 0,
    category_selected: [],
    data: {
      categories: [],
      details: {
        localization: false,
        name: '',
        address: '',
        phone_number: '',
        image: null,
        locale: {
          cantonese: {
            name: '',
            address: '',
            phone_number: ''
          },
          english: {
            name: '',
            address: '',
            phone_number: ''
          },
          mandarin: {
            name: '',
            address: '',
            phone_number: ''
          }
        },
        opening_hours: []
      },
      map_id: null,
      poi: ''
    },
    type: '',
    disabled: false
  },
  mutations: {
    // Init and reset dialog
    INIT_ADD_LOCATION_DIALOG(state, payload) {
      state.type = payload.type
      state.visibility = true
    },
    RESET_ADD_LOCATION_DIALOG(state) {
      state.data = {
        id: 0,
        categories: [],
        details: {
          localization: false,
          name: '',
          address: '',
          phone_number: '',
          image: null,
          locale: {
            cantonese: {
              name: '',
              address: '',
              phone_number: ''
            },
            english: {
              name: '',
              address: '',
              phone_number: ''
            },
            mandarin: {
              name: '',
              address: '',
              phone_number: ''
            }
          },
          opening_hours: []
        },
        map_id: null,
        poi: ''
      }
      state.visibility = false
    },
    SET_ADD_LOCATION_DIALOG_DISABLE_BTN(state, payload) {
      state.disabled = payload
    },

    // select category
    SET_ADD_LOCATION_DIALOG_SELECTED_CATEGORY(state, payload) {
      state.data.categories = payload
    },

    // Edit location dialog
    INIT_EDIT_LOCATION_DIALOG(state, payload) {
      state.type = payload.type
      state.visibility = true
    },
    SET_DATA_EDIT_LOCATION_DIALOG(state, payload) {
      state.data = payload
    }
  },
  actions: {
    async initEditLocation({ commit, dispatch, rootState }, payload) {
      const device_id = rootState.auth.selected_device

      const { location_id, type } = payload
      await dispatch('getLocationInfo', { device_id, location_id })
      await commit('INIT_EDIT_LOCATION_DIALOG', { type: type || '' })
    },
    async getLocationInfo({ commit }, payload) {
      try {
        const { location_id, device_id } = payload
        const response = await api.getLocation({
          location_id,
          params: {
            device_id
          }
        })
        if (response.data.success) {
          if (response.data.data) commit('SET_DATA_EDIT_LOCATION_DIALOG', response.data.data)
        }
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error, icon: 'close', timeout: '2000' })
      }
    },
    async createLocation({ commit, rootState, dispatch }, payload) {
      try {
        commit('SET_ADD_LOCATION_DIALOG_DISABLE_BTN', true)
        const device_id = rootState.auth.selected_device
        const { categories, selected_details, details, map_id, poi } = payload
        let location = {
          device_id: device_id,
          categories: categories || [],
          selected_details: selected_details || [],
          details: details,
          map_id: map_id || null,
          poi: poi || ''
        }
        const response = await api.createLocation(location)
        if (response.data.success) {
          if (response.data.data) {
            commit('SET_LOCATION_AND_MAP_DIALOG_ADD_LOCATION', location)
            dispatch('fetchLocationList')
            commit('RESET_ADD_LOCATION_DIALOG')
            commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.success', ''), icon: 'check', timeout: '2000' })
          }
        }
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_ADD_LOCATION_DIALOG_DISABLE_BTN', false)
      }
    },

    async updateLocation({ commit, rootState, dispatch }, payload) {
      try {
        commit('SET_ADD_LOCATION_DIALOG_DISABLE_BTN', true)
        const { categories, selected_details, details, map_id, poi, location_id } = payload
        const device_id = rootState.auth.selected_device
        let location = {
          device_id: device_id,
          categories: categories || [],
          selected_details: selected_details || [],
          details: details,
          map_id: map_id || null,
          poi: poi || ''
        }
        const response = await api.updateLocation({ location_id, params: location })
        if (response.data.success) {
          dispatch('fetchLocationList')
          commit('RESET_ADD_LOCATION_DIALOG')
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.success', ''), icon: 'check', timeout: '2000' })
        }
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_ADD_LOCATION_DIALOG_DISABLE_BTN', false)
      }
    }
  }
}
